import type { ReactNode } from 'react';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import type { State } from '../../../../state/types.tsx';
import { getIssueParentsWithStatus } from '../../../../state/selectors/header/filters/issue-parent-with-status/selectors.tsx';

import { JpdRoadmapExperimentSpotlight } from './view.tsx';

const mapStateToProps = (
	state: State,
	{ moreSettingsButton }: { moreSettingsButton: ReactNode },
) => ({
	issueParents: getIssueParentsWithStatus(state),
	moreSettingsButton,
});

export default connect(mapStateToProps, {})(JpdRoadmapExperimentSpotlight);
